import {createI18n} from 'vue-i18n'
import en from './locales/en'
import zhCN from './locales/zh-CN'
import zhTW from './locales/zh-TW'

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    messages: {
        'en': en,
        'zh-CN': zhCN,
        'zn-TW': zhTW
    }
})

export default i18n
